<template>
  <div v-if="is_open">
    <div class="embed-video-overlay">
      <div class="embed-video-container">
        <div class="embed-video-container__header">
            <h5 class="position-relative">{{ $t('components.embed_virtual_tour.embed_virtual_tour') }}</h5>
        </div>

        <div class="embed-video-container__body">
            <div class="input-group">
                <input type="text" name="title" placeholder="https://my.matterport.com/show/?m=JGPnGQ6hosj&amp;play=1" class="input" v-model="url">
                <label for="title" class="subtitle text-primary">{{ $t('components.embed_virtual_tour.add_video_link') }}</label>
            </div>
        </div>

        <div class="embed-video-container__footer d-flex">
            <button class="ml-auto button button-m button-secondary mr-16" @click.prevent="clear()">{{ $t('common.cancel') }}</button>
            <button class="button button-m button-primary" @click.prevent="embedTour()">{{ $t('common.save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
        },
        data() {
            return {
                is_open: false,
                url: ""
            }
        },
        mounted() {
            
        },
        methods: {
            clear() {
                this.url = "";
                this.is_open = false;
            },
            embedTour() {
                this.$emit('embedded', this.url)
                this.clear();
            }
        },
        watch: {
        }
    }
</script>
